<template>    
      
      <div class="product-pictures">
        <form action="" @submit="formSubmit">
          <div v-show="isNfe" class="form-inline">            
            <div>
              <h3>{{ $t('etapas.fotos.tituloNfe') }}</h3>
              <dass-send-file
                id="dass-upload-file-nfe"
                @input="attachPictureNfe"                           
                :multiple="true"
              >                
                <template v-slot:label-instructions>                  
                  {{ $t('etapas.fotos.arrasteNfe') }}
                </template>
                <template v-slot:label-separator>{{
                  $t('etapas.fotos.ou')
                }}</template>
                <template  v-slot:upload-button>               
                  {{ $t('etapas.fotos.anexarNFe') }}
                  <dass-icon token="icon-file-attachment" size="25" />
                </template>
              </dass-send-file>
            </div>            
          </div>           
          <div v-show="!isNfe" class="form-inline">            
            <div>
              <h3>{{ $t('etapas.fotos.titulo') }}</h3>
              <dass-send-file
                id="dass-upload-file"
                @input="attachPicture"                           
                :multiple="true"
              >                
                <template v-slot:label-instructions>                  
                  {{ $t('etapas.fotos.arraste') }}
                </template>
                <template v-slot:label-separator>{{
                  $t('etapas.fotos.ou')
                }}</template>
                <template  v-slot:upload-button>               
                  {{ $t('etapas.fotos.anexar') }}
                  <dass-icon token="icon-file-attachment" size="25" />
                </template>
              </dass-send-file>
            </div>            
          </div> 
        </form>
      </div>    
  </template>
<script>
import { mapGetters, mapActions } from 'vuex'
import processHeic from '@/helpers/functions/processHeic'
import validateUpload from '@/helpers/functions/validateUpload'
import { useIsSafari } from '@/composables/useIsSafari'
const refund = 'Estorno'
  
export default {
  name: 'ProductUploadImage', 
  props: {
    isNfe: {
      type: Boolean,
      default: false
    }
  }, 
  data() {
    return {
      isCompressing: false
    }
  },
  computed: {
    ...mapGetters('brand', { brand: 'getBrand' }),
    ...mapGetters('create_protocol', {
      dados_item: 'getDadosItens',
      getPictureList: 'getPictureList'
    }),
  },
  setup() {
    const { isSafari, brandName } = useIsSafari()
    
    return {      
      isSafari,
      brandName
    }     
  },
  watch: {
    getPictureList: {
      handler(newValue, oldValue) {
        this.picture_list = newValue
        if (this.isNfe) {
          const nfeInput = document.querySelector('#dass-upload-file-nfe')
          if (nfeInput) nfeInput.value = ''
        } else {
          const fileInput = document.querySelector('#dass-upload-file')
          if (fileInput) fileInput.value = ''
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions('create_protocol', ['setCurrentStep', 'setPictureList']),
    ...mapActions('toasts', ['showToast']),    
    formSubmit: function (e) {      
      e.preventDefault()
      let pictureList = this.picture_list
      if (pictureList.length == 0) {
        return this.showToast({
          variant: 'warning',
          message: this.$t('etapas.fotos.erroQTDFotos'),
        })
      }      
      if(this.isNfe) {       
        const picturesNfe = this.getPictureList.filter(picture => picture.is_nfe == true)        
        if(picturesNfe.length == 0) {
          return this.showToast({
            variant: 'warning',
            message: this.$t('etapas.fotos.erroQTDNfe'),
          })
        }
      }     
      this.setPictureList(pictureList)      
    },   
    async attachPictureNfe(e) {
      if ((e && e.isTrusted) || this.isCompressing) return

      this.isCompressing = true
      const picturesNfe = this.getPictureList.filter(picture => picture.is_nfe == true)
      const incomingFiles = Array.from(e)
      let errors = []

      const hasHeic = incomingFiles.some(f => f.type === 'image/heic' || f.name.toLowerCase().endsWith('.heic'))
      if (hasHeic) this.showToast({ variant: 'info', message: 'Processando imagens, aguarde...' })

      for (let rawFile of incomingFiles) {
        if (picturesNfe.length >= this.picture_qtd_nfe) continue

        const picture = await processHeic(
          rawFile,
          () => {},
          (nome, motivo) => errors.push(`${nome} (${motivo})`)
        )
        if (!picture) continue

        const { isValid, isImage, isPdf } = validateUpload(picture)
        
        if (!isValid) {
          errors.push(`${picture.name} [${picture.type || this.$t('dass.unknownType')}] (${this.$t('dass.invalidFormat')})`)
          continue
        }

        const fileType = isImage ? 'image' : 'file'

        let temp = {
          original_file: picture,
          object_url: URL.createObjectURL(picture),
          file_type: fileType,
          type: picture.type,
          is_nfe: true
        }
        this.setPictureList([...this.getPictureList, temp])
      }

      this.isCompressing = false

      if (errors.length > 0) {
        this.showToast({ variant: 'error', message: `Falha na conversão: ${errors.join(', ')}` })
      }
    },
    async attachPicture(e) {      
      if ((e && e.isTrusted) || this.isCompressing) return

      this.isCompressing = true
      const picturesPhoto = this.getPictureList.filter(picture => picture.is_nfe == false)
      const incomingFiles = Array.from(e)
      let errors = []

      const hasHeic = incomingFiles.some(f => f.type === 'image/heic' || f.name.toLowerCase().endsWith('.heic'))
      if (hasHeic) this.showToast({ variant: 'info', message: 'Processando imagens, aguarde...' })

      for (let rawFile of incomingFiles) {
        if (picturesPhoto.length >= this.picture_qtd_image) continue

        const picture = await processHeic(
          rawFile,
          () => {},
          (nome, motivo) => errors.push(`${nome} (${motivo})`)
        )
        if (!picture) continue

        const { isValid, isImage, isPdf } = validateUpload(picture)
        
        if (!isValid) {
          errors.push(`${picture.name} [${picture.type || this.$t('dass.unknownType')}] (${this.$t('dass.invalidFormat')})`)
          continue
        }

        const fileType = isImage ? 'image' : 'file'
   
        let temp = {
          original_file: picture,
          object_url: URL.createObjectURL(picture),
          file_type: fileType,
          type: picture.type,
          is_nfe: false
        }
        this.setPictureList([...this.getPictureList, temp])     
      }

      this.isCompressing = false

      if (errors.length > 0) {
        this.showToast({ variant: 'error', message: `Falha na conversão: ${errors.join(', ')}` })
      }
    }, 
    cancel: function () {
      this.$router.go(-1)
    },
    setCssForSafari() {
      const buttonFile = document.querySelector('.dass-send-file--upload-button')    
      switch (this.brandName) {
      case 'fila':
        buttonFile.classList.add('dass-button-primary-fila')
        break
      case 'umbro':
        buttonFile.classList.add('dass-button-primary-umbro')  
        break
      case 'newbalance':
        buttonFile.classList.add('dass-button-primary-newbalance')
        break
      default:
        break
      }
    }
  },  
  mounted: function () {
    if(this.isSafari) {
      this.setCssForSafari()  
    }    
    if(this.getPictureList.length > 0) {
      this.picture_list = this.getPictureList
    }
  },
  data: () => ({
    form_data: {},
    picture_list: [],
    picture_qtd_image: 5,
    picture_qtd_nfe: 3,       
  }),
}
</script>
  
  <style lang="scss" scoped>
  .product-pictures {
    text-align: left;  
    form {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      .form-inline {
        width: 100%;
        > div > h3 {
          display: flex;
          justify-content: center;
        }
      } 
      .actions {
        > button:first-of-type {
          margin-right: var(--space);
        }
        display: flex;
        width: 100%;
        justify-content: flex-end;
        align-items: center;
      }
    }
    #dass-button-tertiary-close-umbro {
      color: var(--theme-color) !important;    
    }
  }
  </style>  